import { render, staticRenderFns } from "./Hot.vue?vue&type=template&id=63be88b6&"
import script from "./Hot.vue?vue&type=script&lang=js&"
export * from "./Hot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63be88b6')) {
      api.createRecord('63be88b6', component.options)
    } else {
      api.reload('63be88b6', component.options)
    }
    module.hot.accept("./Hot.vue?vue&type=template&id=63be88b6&", function () {
      api.rerender('63be88b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/forum/Hot.vue"
export default component.exports